import { FlexRow } from '@gorila-shared-ui/components';
import { useRecoilState } from 'recoil';
import { reportAlarmFilterState } from '../../../storage/reports';
import AlarmTypeSelect from '../../shared/alarmTypeSelect';

function AlarmsReportFilters() {
  const [alarm, setAlarm] = useRecoilState(reportAlarmFilterState);

  return (
    <FlexRow>
      <AlarmTypeSelect
        alarmTypeId={alarm === undefined ? undefined : `${alarm}`}
        onChange={(alarmId) => setAlarm(alarmId ? +alarmId : undefined)}
        fullWidth
      />
    </FlexRow>
  );
}

export default AlarmsReportFilters;
